import { Button, CircularProgress } from '@mui/material'
import { useEffect, useRef, useState } from 'react'

const AITutorRoeplayLivekit = () => {
  const chatContainerRef = useRef<HTMLDivElement>(null)

  const [logList, setLogList] = useState<string[]>([])

  function addLog(log: string) {
    setLogList((prev) => [...prev, log])
  }

  const [recordingStatus, setRecordingStatus] = useState<'idle' | 'starting' | 'recording' | 'sending'>('idle')

  const [isWaiting, setIsWaiting] = useState(true)

  const [participantCount, setParticipantCount] = useState(0)
  const [recordingTranscription, setRecordingTranscription] = useState('')
  const [contextDescription, setContextDescription] = useState('')
  const [hasTalkedEnough, setHasTalkedEnough] = useState(false)
  const [isAgentTalking, setIsAgentTalking] = useState(false)
  const [chatMessages, setChatMessages] = useState<
    { id: string; role: 'system' | 'assistant' | 'user'; message: string }[]
  >([])

  useEffect(() => {
    const listener = (event) => {
      const data = JSON.parse(event.data)
      if (!data.type.startsWith('RECORD_')) {
        return
      }
      if (data.type !== 'RECORD_LIVEKIT_NUM') {
        addLog(`${new Date().toISOString()} ${data.type}`)
      }

      if (data.type === 'RECORD_RESPONSE_START_SUCCESS') {
        // alert('RECORD_RESPONSE_START_SUCCESS from RN')
        setRecordingStatus('recording')
      } else if (data.type === 'RECORD_RESPONSE_START_FAILED') {
        setRecordingStatus('idle')
      } else if (data.type === 'RECORD_RESPONSE_END_SUCCESS') {
        setRecordingStatus('idle')
      } else if (data.type === 'RECORD_RESPONSE_END_FAILED') {
        setRecordingStatus('idle')
      } else if (data.type === 'RECORD_LIVEKIT_NUM') {
        setParticipantCount(data.payload)
        // addLog(data.type)
      } else if (data.type === 'RECORD_LIVEKIT_TRANSCRIPTION') {
        setRecordingTranscription(data.payload)
      } else if (data.type === 'RECORD_CHAT_MESSAGES') {
        setChatMessages(data.payload)
      } else if (data.type === 'RECORD_CHAT_CONTEXT_DESCRIPTION') {
        console.log('context description', data.payload)
        setContextDescription(data.payload)
      } else if (data.type === 'RECORD_ASSISTANT_SPEECH_ENDED') {
        alert('assistnat speech ended')
      } else if (data.type === 'RECORD_IS_AGENT_TALKING') {
        setIsAgentTalking(data.payload)
      }
    }
    window.addEventListener('message', listener)
    window.document.addEventListener('message', listener)
    return () => {
      window.removeEventListener('message', listener)
      window.document.removeEventListener('message', listener)
    }
  }, [])

  useEffect(() => {
    if (participantCount > 0) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'RECORD_LIVEKIT_START' }))
    }
  }, [participantCount])

  useEffect(() => {
    //when message is being produced.
    if (chatMessages.length >= 1) {
      setIsWaiting(false)
    }

    chatContainerRef.current?.scrollTo({
      top: chatContainerRef.current.scrollHeight,
      behavior: 'smooth',
    })

    if (chatMessages.length >= 20) {
      setHasTalkedEnough(true)
    }
  }, [chatMessages])

  useEffect(() => {
    if (hasTalkedEnough) {
      alert('20 turns')
    }
  }, [hasTalkedEnough])

  const totalUserWords = chatMessages.reduce((sum, msg) => {
    if (msg.role !== 'user') return sum
    return sum + msg.message.trim().split(/\s+/).length
  }, 0)

  return (
    <div
      className="flex flex-col overflow-hidden"
      style={{ height: 'calc(100vh - env(safe-area-inset-top))', border: '3px solid blue' }}
    >
      {participantCount === 0 && (
        <>
          <div>loading..</div>
        </>
      )}

      {isWaiting && <CircularProgress />}

      <div
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <div
          ref={chatContainerRef}
          style={{ flex: 2 }}
          className="flex-1 overflow-x-hidden overflow-auto flex flex-col items-center"
        >
          {chatMessages.map((msg) => (
            <>
              {msg.role === 'system' && (
                <div key={msg.id} className="mt-10 ml-10 mr-64 self-start flex flex-col items-star">
                  <p>
                    <b>{msg.role}</b>
                  </p>
                  <p className="rounded-lg text-gray-600 p-4">{msg.message}</p>
                </div>
              )}
              {msg.role === 'assistant' && (
                <div key={msg.id} className="mt-10 ml-10 mr-64 self-start flex flex-col items-star">
                  <p>
                    <b>{msg.role}</b>
                  </p>
                  <p className="rounded-lg bg-gray-100 p-4">{msg.message}</p>
                </div>
              )}
              {msg.role === 'user' && (
                <div key={msg.id} className="mt-10 mr-10 ml-64 self-end flex flex-col items-end">
                  <p>
                    <b>{msg.role}</b>
                  </p>
                  <p className="rounded-lg bg-gray-100 p-4">{msg.message}</p>
                </div>
              )}
            </>
          ))}
        </div>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Button
            onClick={() => {
              window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'ROUTER_BACK' }))
            }}
          >
            Back
          </Button>
          <br />
          <div>Total word count: {totalUserWords} | </div>
          <br />
          <div>Total Turn: {chatMessages.length}</div>
          <br />
        </div>

        <div>
          {recordingStatus}
          <br />
          {isAgentTalking && <>Agent Talking</>}
        </div>

        <div
          style={{
            backgroundColor: 'gold',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flex: 0.5,
          }}
        >
          <button
            style={{
              padding: 8,
              margin: 8,
            }}
            onClick={() => {
              setRecordingStatus('idle')
              window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'RECORD_RESET' }))
            }}
          >
            RESET
          </button>
          <button
            style={{
              padding: 8,
              margin: 8,
            }}
            onClick={() => {
              window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'RECORD_LIVEKIT_CONNECT' }))
            }}
          >
            CONNECT
          </button>

          <button
            style={{
              padding: 8,
              margin: 8,
            }}
            onClick={() => {
              // if (participantCount > 0) {
              //   alert('already started. no rpc')
              //   return
              // }
              if (participantCount > 0) {
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'RECORD_LIVEKIT_START' }))
              }
            }}
          >
            START {participantCount} | RPC
          </button>
        </div>
        <div style={{ border: '1px solid red' }}>
          {recordingStatus === 'idle' && (
            <div
              style={{
                width: 128,
                height: 128,
                borderRadius: 64,
                backgroundColor: 'red',
                marginBottom: 16,
                marginLeft: 16,
                marginRight: 16,
              }}
              onClick={() => {
                addLog('RECORD_START')
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'RECORD_START' }))
                setRecordingStatus('starting')
                console.log('hello')
              }}
            ></div>
          )}
          {(recordingStatus === 'starting' || recordingStatus === 'sending') && (
            <div
              style={{
                width: 128,
                height: 128,
                borderRadius: 64,
                backgroundColor: 'blue',
                marginBottom: 16,
                marginLeft: 16,
                marginRight: 16,
              }}
              onClick={() => {
                // alert('let us end conv')
              }}
            ></div>
          )}
          {recordingStatus === 'recording' && (
            <div
              style={{
                width: 128,
                height: 128,
                borderRadius: 64,
                backgroundColor: 'green',
                marginBottom: 16,
                marginLeft: 16,
                marginRight: 16,
              }}
              onClick={() => {
                addLog('RECORD_START')
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'RECORD_END' }))
                setRecordingStatus('sending')
              }}
            ></div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AITutorRoeplayLivekit
